<section [@pageLoader]='statusLoader' class="loading full-page">
    <div class="loading-wrapper">
        <mat-icon svgIcon="ico-loading-puff" class="custom-mat-icon ico-size ico-lg"></mat-icon>
    </div>
    <div class="overlay-background"></div>
</section>